import { useEffect, useRef } from "react";

const DEFAULT_SCHEDULE_DELAY = 500;

/**
 * Schedules function for execution after delay
 * @param delay wait in ms before action is executed
 */
export function useScheduler(delay: number = DEFAULT_SCHEDULE_DELAY) {
  const timerRef = useRef<NodeJS.Timeout>();

  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  return {
    schedule: (func: () => void) => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      timerRef.current = setTimeout(func, delay);
    },
    cancel: () => clearTimeout(timerRef.current),
  };
}
